import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /global-search?paginated=true
 * @returns {AxiosPromise<any>}
 */
export const GET_GLOBAL_SEARCH_RESULTS = params => request.get('/global-search?paginated=true', { params })

/**
 * @description GET /global-search-top?query={query}
 * @returns {AxiosPromise<any>}
 */
export const GET_GLOBAL_SEARCH_TOP_RESULTS = query => request.get(`/global-search-top?query=${query}`)
